import { getAbTestV2, trackAbTestV2Variant } from 'dibs-ab-tests/exports/clientAbTestV2.ts';

const EXPAND_APP_DOWNLOAD_TEST_NAME = 'expandAppDownloadTriggers_Jan2026';
const FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME = 'fullScreenAppDownloadDesign_May2026';

function getExpandAppDownloadTestVariant(): string | undefined {
    return getAbTestV2(EXPAND_APP_DOWNLOAD_TEST_NAME)?.variant;
}

function trackExpandAppDownloadAbTest(): void {
    trackAbTestV2Variant(EXPAND_APP_DOWNLOAD_TEST_NAME);
}

function isFullScreenAppDownloadDesignTestVariant(): boolean {
    return getAbTestV2(FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME)?.variant === 'variant';
}

function trackFullScreenAppDownloadDesignAbTest(): void {
    trackAbTestV2Variant(FULL_SCREEN_APP_DOWNLOAD_DESIGN_TEST_NAME);
}

export {
    getExpandAppDownloadTestVariant,
    trackExpandAppDownloadAbTest,
    isFullScreenAppDownloadDesignTestVariant,
    trackFullScreenAppDownloadDesignAbTest,
};
